import { ReactNode } from 'react';
import { useTranslation } from '../../../lib/i18n';
import { upgradeHref } from '../../../lib/upgrade-origin';
import { Button } from '../ui';
import styles from './connectors.module.css';

export function Section({ title, count, children }: { title: string; count?: number; children: ReactNode }) {
  return (
    <section>
      <h2 className={`sym-h2 ${styles.sectionTitle}`}>
        {title}
        {typeof count === 'number' && <span className={styles.sectionCount}>{` · ${count}`}</span>}
      </h2>
      {children}
    </section>
  );
}

export function ErrorLine({ message, upgrade }: { message: string; upgrade?: boolean }) {
  return (
    <div role="alert" className={styles.errorLine}>
      {message}
      {upgrade && <UpgradeButton />}
    </div>
  );
}

/** The plan picker, tagged as coming from a plan-only connector's refusal. */
export function UpgradeButton() {
  const { t } = useTranslation();
  return (
    <Button color="accent" size="small" href={upgradeHref('connector_premium_only')}>
      {t('sidebar.credits.upgrade')}
    </Button>
  );
}

export function EmptyCard({ message }: { message: string }) {
  return <div className={styles.emptyCard}>{message}</div>;
}

export function CardGridSkeleton({ count }: { count: number }) {
  return (
    <div className={styles.grid}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.card}>
          <div className={styles.main}>
            <div className="orion-shimmer" style={{ width: 40, height: 40, borderRadius: 10, flexShrink: 0 }} />
            <div className={styles.text} style={{ gap: 8 }}>
              <div className="orion-shimmer" style={{ height: 13, width: '55%' }} />
              <div className="orion-shimmer" style={{ height: 11, width: '85%' }} />
            </div>
            <div className="orion-shimmer" style={{ width: 74, height: 30, borderRadius: 10, flexShrink: 0 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function ConnectorLoadError({ retry }: { retry: () => Promise<void> }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className={styles.errorLine}>
      <span>{t('connections.error')}</span>
      <Button variant="text" size="small" onClick={() => { void retry(); }}>
        {t('common.retry')}
      </Button>
    </div>
  );
}
